import { http } from '../../axios';
import { shopPrefix } from '../../../config';
import { SubscriptionRenewalLineItemUpdate, RenewalLineOut } from '../../../store/api';

const endpoint = `${shopPrefix}/v1/subscription-management/renewals/:productId`;

export interface SubscriptionRenewalLineUpdateRequest {
    type: 'RECOMMENDED' | 'SAME_AS_CURRENT_YEAR' | 'CUSTOM' | 'DONT_RENEW' | 'ALREADY_RENEWED' | 'UNAVAILABLE';
    lineItems: SubscriptionRenewalLineItemUpdate[] | null;
}

export type UpdateLineItemsParams = SubscriptionRenewalLineUpdateRequest & { productId: string };

export const updateRenewalLine = ({ productId, ...body }: UpdateLineItemsParams) => {
    return http
        .post<RenewalLineOut>(endpoint, body, {
            pathParams: {
                productId
            }
        })
        .then(res => res.data);
};
